import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MmAlertContentAlign, MmAlertSize, MmAlertType } from '@metromarkets/components';
import { BuyerType, PaymentMethod, PaymentMethodCode } from '~shared/constants';
import { ORDER_DETAILS_DATE_FORMAT } from '../../constants';
import { OrderHistoryItem } from '../../models';
import { SOFORT_SVG } from '~shared/constants/payment-type.constants';


@Component({
  selector: 'app-order-history-details',
  templateUrl: './order-history-details.component.html',
  styleUrls: ['./order-history-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderHistoryDetailsComponent {
  public readonly buyerType = BuyerType;
  public readonly dateFormat = ORDER_DETAILS_DATE_FORMAT;
  public readonly paymentMethod = PaymentMethod;
  public readonly paymentMethodCode = PaymentMethodCode;
  public sofortSVG = SOFORT_SVG();

  @Input() order: OrderHistoryItem;
  @Input() isFirstOrder: boolean;
  @Input() isEnabledPaymentMethodCode: boolean;
  @Output() accordianClicked = new EventEmitter<boolean>();

  @ViewChild('openInvoiceAlertTemplate', { static: true }) openInvoiceAlertTemplate: TemplateRef<HTMLElement>;

  get openInvoiceAlertConfig(): any {
    return {
      type: MmAlertType.info,
      size: MmAlertSize.large,
      contentAlign: MmAlertContentAlign.left,
      template: this.openInvoiceAlertTemplate,
      disableCloseIcon: true
    };
  }
  isExpanded(params){
    this.accordianClicked.emit(params?.expanded);
  }
}
